import { useState, useEffect, useRef } from "react";
import BotonMapaProceso from "./BotonMapaProceso";
import { supabase } from "./supabase";
import { getUsuarios, setUsuarios, getPermisosLocales, setPermisosLocales,
         ROLES, MODULOS, guardarUsuarioSupabase, guardarPermisosSupabase,
         getTabsConsultorHS, syncUsuariosDesdeSupabase, syncPermisosDesdeSupabase } from "./GestorUsuarios";
// Los endpoints /api/crear-usuario y /api/gestionar-usuario (que reemplaza a
// /api/editar-usuario y /api/eliminar-usuario, fusionados para no superar el
// límite de 12 Serverless Functions de Vercel Hobby) ahora exigen un token de
// sesión Supabase válido de un Administrador (fix de la auditoría, Fase 3
// Paso 1) -- este helper arma el header Authorization con el access_token de
// la sesión activa.
async function authHeaders() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token || "";
  return { "Content-Type": "application/json", "Authorization": `Bearer ${token}` };
}
const BUCKET_LOGOS = "logos-empresa";
const LOGO_MAX_BYTES = 500 * 1024; // 500KB -- se cachea como base64 en localStorage al loguear, sin límite generoso infla la sesión de todo el equipo
// Sube el logo con el tenant_id como primer segmento del path -- mismo
// patrón que certificados-calidad (Fase 12): las policies RLS del bucket
// (ver setup_bucket_logos-empresa.sql) filtran exactamente por ese segmento.
async function subirLogoEmpresa(archivo, tenantId) {
  if (!tenantId) throw new Error("Sesión sin tenant_id -- no se puede subir el logo.");
  const ext = (archivo.name.split('.').pop() || 'png').toLowerCase();
  const path = `${tenantId}/logo_${Date.now()}.${ext}`;
  const { error } = await supabase.storage.from(BUCKET_LOGOS).upload(path, archivo, { contentType: archivo.type, upsert: true });
  if (error) throw error;
  return path;
}
export default function AdminUsuarios({ onVolver, oscuro, usuario }) {
  const [usuarios, setUsuariosState] = useState(() => getUsuarios());
  const [vista, setVista] = useState("listado");
  const [form, setForm] = useState({ rol: "Calidad", activo: true });
  const [confirmEliminar, setConfirmEliminar] = useState(null);
  const [errores, setErrores] = useState({});
  const [editando, setEditando] = useState(null);
  const [usuarioPermisos, setUsuarioPermisos] = useState(null);
  const [modulosHab, setModulosHab] = useState([]);
  const [tabsConsultorHS49, setTabsConsultorHS49] = useState({ visitas:true, perfil:true, normativas:true, hallazgos:true, normaria:true, aspectos:true, programa:true });
  const [guardandoPermisos, setGuardandoPermisos] = useState(false);
  // Logo de empresa: archivo elegido en esta sesión de formulario
  // (transitorio, se sube recién al guardar). form.logo_url ya trae el path
  // existente cuando se abre a editar un usuario que ya tiene uno cargado.
  const [archivoLogo, setArchivoLogo] = useState(null);
  // Mismo patrón de dos botones que el certificado de calidad
  // (IngresoMateriales.js): capture solo dispara la cámara de forma
  // confiable cuando accept es exclusivamente image/*.
  const inputFotoLogoRef = useRef(null);
  const inputArchivoLogoRef = useRef(null);
  const [guardandoUsuario, setGuardandoUsuario] = useState(false);
  const [organizaciones, setOrganizaciones] = useState([]);
  const [nuevaOrg, setNuevaOrg] = useState(false);
  const [busqueda, setBusqueda] = useState("");
  // Fase D2 -- null = sin restricción (plan sin filas cargadas todavía); si tiene
  // datos, es el set de ids (como texto) de módulos que el plan del tenant
  // incluye. Se usa SOLO para mostrar en gris los módulos fuera del plan en la
  // pantalla de Permisos -- el corte real de acceso sigue pasando en
  // autenticarSupabase (GestorUsuarios.js), esto es nada más para que esta
  // pantalla no le mienta al Administrador del tenant mostrando como
  // "habilitado" algo que su plan no deja usar de verdad.
  const [modulosDelPlan, setModulosDelPlan] = useState(null);
  useEffect(() => {
    syncUsuariosDesdeSupabase();
    syncPermisosDesdeSupabase();
    // Cargar organizaciones existentes
    supabase.from("organizaciones").select("id, nombre").eq("estado", "activo").order("nombre")
      .then(({ data }) => { if (data) setOrganizaciones(data); });
  }, []);
  useEffect(() => {
    if (!usuario?.tenant_id) return;
    (async () => {
      const { data: tenantPlan } = await supabase.from("tenants").select("plan_id").eq("id", usuario.tenant_id).single();
      if (!tenantPlan?.plan_id) return;
      const { data: planModulos } = await supabase.from("plan_modulos").select("modulo_key").eq("plan_id", tenantPlan.plan_id).eq("habilitado", true);
      if (planModulos?.length) {
        setModulosDelPlan(new Set(planModulos.map(p => String(p.modulo_key))));
      }
    })();
  }, [usuario?.tenant_id]);
  const bg      = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg  = oscuro ? "#0d2160" : "white";
  const texto   = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde   = oscuro ? "#1e3a8a" : "#eee";
  const navBg   = oscuro ? "#060f30" : "#09184D";
  const subtexto= oscuro ? "#9aabd4" : "#808085";
  const inp = { width:"100%", padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", boxSizing:"border-box", marginTop:"4px", background:cardBg, color:texto };
  const lbl = { fontSize:"12px", color:oscuro?"#9aabd4":"#555", fontWeight:"600", display:"block", marginTop:"12px" };
  const card= { background:cardBg, borderRadius:"12px", padding:"1.5rem", border:`1px solid ${borde}`, marginBottom:"12px" };
  const validar = () => {
    const e = {};
    if (!editando && !form.nombre?.trim()) e.nombre = "Requerido";
    if (!editando && !form.email?.trim()) e.email = "Requerido";
    else if (!editando && form.email?.trim() && usuarios.find(u => u.email?.toLowerCase() === form.email.toLowerCase())) e.email = "Ya existe";
    if (!form.password?.trim() && !editando) e.password = "Requerido";
    if (form.password && form.password.length < 6) e.password = "Mínimo 6 caracteres";
    if (!editando && !form.empresa?.trim()) e.empresa = "Requerido";
    if (!form.rol) e.rol = "Requerido";
    setErrores(e);
    return Object.keys(e).length === 0;
  };
  const guardar = async () => {
    if (!validar()) return;
    let logoPathNuevo = null;
    if (archivoLogo) {
      try {
        logoPathNuevo = await subirLogoEmpresa(archivoLogo, usuario?.tenant_id);
      } catch (e) {
        setErrores({ empresa: "No se pudo subir el logo: " + e.message });
        return;
      }
    }
    if (editando) {
      setGuardandoUsuario(true);
      try {
        const resp = await fetch("/api/gestionar-usuario", {
          method: "POST",
          headers: await authHeaders(),
          body: JSON.stringify({
            accion: "editar",
            usuario_id: editando.id,
            auth_id: editando.auth_id || null,
            nombre: form.nombre,
            email: form.email,
            celular: form.celular || "",
            rol: form.rol,
            empresa: form.empresa,
            empresa_direccion: form.empresa_direccion || "",
            empresa_cuit: form.empresa_cuit || "",
            ...(logoPathNuevo ? { logo_url: logoPathNuevo } : {}),
            activo: form.activo,
            ...(form.password ? { password: form.password } : {}),
          }),
        });
        const data = await resp.json();
        if (!resp.ok || data.error) {
          setErrores({ email: data.error || "Error actualizando usuario" });
          setGuardandoUsuario(false);
          return;
        }
      } catch (e) {
        setErrores({ email: "Error de conexión: " + e.message });
        setGuardandoUsuario(false);
        return;
      }
      setGuardandoUsuario(false);
      const usuarioFinal = { ...editando, nombre:form.nombre, email:form.email, celular:form.celular||"", rol:form.rol, empresa:form.empresa, empresa_direccion:form.empresa_direccion||"", empresa_cuit:form.empresa_cuit||"", logo_url: logoPathNuevo || editando.logo_url, activo:form.activo };
      const actuales = getUsuarios();
      const actualizados = actuales.map(u => u.id === editando.id ? usuarioFinal : u);
      setUsuarios(actualizados); setUsuariosState(actualizados);
      // Actualizar vínculo de organización
      try {
        await supabase.from("usuario_organizaciones").delete().eq("usuario_id", editando.id);
        const orgNombre = (form.organizacion||"").trim();
        if (orgNombre) {
          let { data: orgExistente } = await supabase.from("organizaciones").select("id").eq("nombre", orgNombre).maybeSingle();
          let orgId = orgExistente?.id;
          if (!orgId) {
            const { data: orgNueva } = await supabase.from("organizaciones").insert({ nombre: orgNombre, plan:"pyme", estado:"activo", tenant_id: Number(localStorage.getItem("alqos_tenant_id")) || null }).select("id").single();
            orgId = orgNueva?.id;
          }
          if (orgId) {
            await supabase.from("usuario_organizaciones").upsert({ usuario_id: editando.id, organizacion_id: orgId, rol_en_org: form.rol, tenant_id: Number(localStorage.getItem("alqos_tenant_id")) || null }, { onConflict: "usuario_id,organizacion_id" });
          }
        }
      } catch(e) { console.warn("Error actualizando organización:", e); }
      setForm({ rol:"Calidad", activo:true }); setArchivoLogo(null); setErrores({}); setEditando(null); setVista("listado");
      return;
    }
    // Usuario nuevo: crear en Supabase Auth + tabla usuarios + organización (si corresponde)
    setGuardandoUsuario(true);
    try {
      const resp = await fetch("/api/crear-usuario", {
        method: "POST",
        headers: await authHeaders(),
        body: JSON.stringify({
          email: form.email,
          password: form.password,
          nombre: form.nombre,
          rol: form.rol,
          empresa: form.empresa,
          empresa_direccion: form.empresa_direccion || "",
          empresa_cuit: form.empresa_cuit || "",
          logo_url: logoPathNuevo,
          celular: form.celular || "",
          organizacion_nombre: form.organizacion || "",
          rol_en_org: form.rol,
        }),
      });
      const data = await resp.json();
      if (!resp.ok || data.error) {
        setErrores({ email: data.error || "Error creando usuario" });
        setGuardandoUsuario(false);
        return;
      }
      // Refrescar lista directo desde Supabase
      const { data: nuevosUsuarios } = await supabase.from("usuarios").select("*");
      if (nuevosUsuarios?.length) {
        setUsuarios(nuevosUsuarios);
        setUsuariosState(nuevosUsuarios);
      }
      setForm({ rol:"Calidad", activo:true }); setArchivoLogo(null); setErrores({}); setEditando(null); setVista("listado");
    } catch (e) {
      setErrores({ email: "Error de conexión: " + e.message });
    } finally {
      setGuardandoUsuario(false);
    }
  };
  // Protección contra quedarse sin ningún Administrador activo -- ni por accidente
  // ni borrándose/desactivándose a sí mismo. usuario acá es el usuario logueado
  // (la sesión actual), no el que se está por borrar/desactivar.
  const quedariaSinAdminActivo = (idAfectado) => {
    const objetivo = usuarios.find(u => u.id === idAfectado);
    if (!objetivo || objetivo.rol !== "Administrador") return false;
    const otrosAdminsActivos = usuarios.filter(u => u.rol === "Administrador" && u.activo && u.id !== idAfectado).length;
    return otrosAdminsActivos === 0;
  };
  const eliminar = async (id) => {
    if (id === 1) return;
    if (id === usuario?.id) { alert("No podés eliminar tu propio usuario mientras estás logueada con él."); setConfirmEliminar(null); return; }
    if (quedariaSinAdminActivo(id)) { alert("No se puede eliminar: es el único Administrador activo. Activá o creá otro Administrador primero."); setConfirmEliminar(null); return; }
    const u = usuarios.find(x => x.id === id);
    try {
      const resp = await fetch("/api/gestionar-usuario", {
        method: "POST",
        headers: await authHeaders(),
        body: JSON.stringify({ accion: "eliminar", usuario_id: id, auth_id: u?.auth_id || null }),
      });
      const data = await resp.json();
      if (data.error) { alert("Error eliminando usuario: " + data.error); setConfirmEliminar(null); return; }
    } catch (e) { alert("Error de conexión: " + e.message); setConfirmEliminar(null); return; }
    const { data: actualizados } = await supabase.from("usuarios").select("*");
    if (actualizados) { setUsuarios(actualizados); setUsuariosState(actualizados); }
    setConfirmEliminar(null);
  };
  const toggleActivo = async (id) => {
    if (id === 1) return;
    const objetivo = usuarios.find(u => u.id === id);
    const seDesactiva = objetivo?.activo === true; // va a pasar a false
    if (seDesactiva && id === usuario?.id) { alert("No podés desactivar tu propio usuario mientras estás logueada con él."); return; }
    if (seDesactiva && quedariaSinAdminActivo(id)) { alert("No se puede desactivar: es el único Administrador activo. Activá o creá otro Administrador primero."); return; }
    const actualizados = usuarios.map(u => u.id === id ? { ...u, activo:!u.activo } : u);
    setUsuarios(actualizados); setUsuariosState(actualizados);
    const u = actualizados.find(u => u.id === id);
    await guardarUsuarioSupabase(u);
  };
  const abrirPermisos = (u) => {
    const permisosLocales = getPermisosLocales();
    const custom = permisosLocales[u.id];
    const modulosBase = ROLES[u.rol]?.modulosVisibles;
    let habilitados;
    if (custom) {
      habilitados = MODULOS.filter(m => custom[String(m.id)] === true).map(m => m.id);
    } else if (modulosBase === "todos") {
      habilitados = MODULOS.map(m => m.id);
    } else {
      habilitados = modulosBase || [];
    }
    setModulosHab(habilitados);
    setTabsConsultorHS49(getTabsConsultorHS(custom));
    setUsuarioPermisos(u);
    setVista("permisos");
  };
  const toggleModulo = (id) => {
    setModulosHab(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  const guardarPermisos = async () => {
    setGuardandoPermisos(true);
    const permisosLocales = getPermisosLocales();
    const mapa = {};
    MODULOS.forEach(m => { mapa[String(m.id)] = modulosHab.includes(m.id); });
    Object.entries(tabsConsultorHS49).forEach(([tab, val]) => { mapa[`49_tab_${tab}`] = val; });
    permisosLocales[usuarioPermisos.id] = mapa;
    setPermisosLocales(permisosLocales);
    await guardarPermisosSupabase(usuarioPermisos.id, modulosHab, tabsConsultorHS49);
    setGuardandoPermisos(false);
    setVista("listado");
  };
  const Header = ({ titulo, onBack }) => (
    <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", gap:"12px", position:"sticky", top:0, zIndex:100, marginBottom:"1.5rem" }}>
      <button onClick={onBack} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
      <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>{titulo}</span>
    </div>
  );
  // ── VISTA PERMISOS ──
  if (vista === "permisos") return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <Header titulo={`🔐 Permisos — ${usuarioPermisos.nombre}`} onBack={() => setVista("listado")} />
      <div style={{ padding:"0 1.5rem 2rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={{ background:cardBg, borderRadius:"12px", padding:"1rem 1.2rem", border:`1px solid ${borde}`, marginBottom:"12px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div>
            <p style={{ fontSize:"13px", fontWeight:"700", color:texto, margin:0 }}>{usuarioPermisos.nombre}</p>
            <p style={{ fontSize:"11px", color:subtexto, margin:"2px 0 0" }}>{ROLES[usuarioPermisos.rol]?.label} · {usuarioPermisos.empresa}</p>
          </div>
          <div style={{ display:"flex", gap:"6px" }}>
            <button onClick={() => setModulosHab((modulosDelPlan ? MODULOS.filter(m => modulosDelPlan.has(String(m.id))) : MODULOS).map(m=>m.id))} style={{ padding:"5px 10px", background:"#22c55e22", border:"1px solid #22c55e", borderRadius:"8px", cursor:"pointer", color:"#15803d", fontSize:"11px", fontWeight:"600" }}>
              ✓ Todos
            </button>
            <button onClick={() => setModulosHab([])} style={{ padding:"5px 10px", background:"#e6394622", border:"1px solid #e63946", borderRadius:"8px", cursor:"pointer", color:"#e63946", fontSize:"11px", fontWeight:"600" }}>
              ✗ Ninguno
            </button>
          </div>
        </div>
        {modulosDelPlan && (
          <p style={{ fontSize:"11px", color:subtexto, margin:"0 0 10px", fontStyle:"italic" }}>
            🔒 Los módulos en gris no están incluidos en el plan actual del tenant — para habilitarlos hay que ampliar el plan.
          </p>
        )}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(180px,1fr))", gap:"8px", marginBottom:"16px" }}>
          {MODULOS.map(m => {
            const hab = modulosHab.includes(m.id);
            const enPlan = !modulosDelPlan || modulosDelPlan.has(String(m.id));
            return (
              <button key={m.id} onClick={() => enPlan && toggleModulo(m.id)} disabled={!enPlan}
                style={{ padding:"10px 12px", borderRadius:"10px", border:`1.5px solid ${!enPlan?"#dde3f0":hab?"#7B5BF2":"#dde3f0"}`, background:!enPlan?(oscuro?"#0a1030":"#f0f0f3"):hab?"#f5f3ff":cardBg, cursor:enPlan?"pointer":"not-allowed", opacity:enPlan?1:0.45, textAlign:"left", display:"flex", alignItems:"center", gap:"8px", transition:"all .15s" }}>
                <span style={{ fontSize:"16px" }}>{m.icono}</span>
                <div>
                  <p style={{ fontSize:"11px", fontWeight:"600", color:!enPlan?subtexto:hab?"#7B5BF2":texto, margin:0 }}>{m.nombre}</p>
                  <p style={{ fontSize:"9px", color:!enPlan?subtexto:hab?"#9B7BFF":subtexto, margin:"1px 0 0" }}>{!enPlan?"🔒 No incluido en tu plan":hab?"✓ Habilitado":"✗ Bloqueado"}</p>
                </div>
              </button>
            );
          })}
        </div>
        {usuario?.rol === "Administrador" && Number(usuario?.tenant_id) === 1 && (
          <div style={{ background:cardBg, borderRadius:"12px", padding:"1rem 1.2rem", border:"1.5px solid #7B5BF2", marginBottom:"16px" }}>
            <p style={{ fontSize:"12px", fontWeight:"700", color:"#7B5BF2", margin:"0 0 10px" }}>🔍 Portal Asesores — pestañas visibles</p>
            <div style={{ display:"flex", flexWrap:"wrap", gap:"8px" }}>
              {[["visitas","📋 Visitas"],["perfil","🏭 Perfil empresa"],["normativas","📜 Normativas"],
                ["hallazgos","🚨 Hallazgos"],["normaria","🤖 Análisis Legal"],
                ["aspectos","🌿 Aspectos Amb."],["programa","📅 Prog. Anual"]].map(([key, label]) => {
                const activa = tabsConsultorHS49[key] ?? true;
                return (
                  <button key={key} onClick={() => setTabsConsultorHS49(prev => ({ ...prev, [key]: !prev[key] }))}
                    style={{ padding:"6px 12px", borderRadius:"8px", fontSize:"11px", fontWeight:"600", cursor:"pointer",
                      border:`1.5px solid ${activa?"#7B5BF2":"#dde3f0"}`,
                      background:activa?"#f5f3ff":cardBg, color:activa?"#7B5BF2":subtexto }}>
                    {activa ? "✓ " : "✗ "}{label}
                  </button>
                );
              })}
            </div>
          </div>
        )}
        <button onClick={guardarPermisos} disabled={guardandoPermisos}
          style={{ width:"100%", padding:"14px", background:"#7B5BF2", color:"white", border:"none", borderRadius:"10px", fontSize:"15px", fontWeight:"600", cursor:"pointer", opacity:guardandoPermisos?.7:1 }}>
          {guardandoPermisos ? "Guardando..." : "💾 Guardar permisos"}
        </button>
      </div>
    </div>
  );
  // ── CONFIRM ELIMINAR ──
  if (confirmEliminar) return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif", display:"flex", alignItems:"center", justifyContent:"center" }}>
      <div style={{ background:cardBg, borderRadius:"16px", padding:"2rem", maxWidth:"360px", width:"90%", border:`1px solid ${borde}`, textAlign:"center" }}>
        <p style={{ fontSize:"32px", marginBottom:"1rem" }}>👤</p>
        <p style={{ fontSize:"15px", fontWeight:"600", color:texto, marginBottom:".5rem" }}>¿Eliminar este usuario?</p>
        <p style={{ fontSize:"13px", color:subtexto, marginBottom:"1.5rem" }}>Esta acción no se puede deshacer.</p>
        <div style={{ display:"flex", gap:"10px", justifyContent:"center" }}>
          <button onClick={() => setConfirmEliminar(null)} style={{ padding:"10px 20px", background:"none", border:`1px solid ${borde}`, borderRadius:"10px", cursor:"pointer", color:texto, fontSize:"13px" }}>Cancelar</button>
          <button onClick={() => eliminar(confirmEliminar)} style={{ padding:"10px 20px", background:"#e63946", border:"none", borderRadius:"10px", cursor:"pointer", color:"white", fontSize:"13px", fontWeight:"600" }}>Eliminar</button>
        </div>
      </div>
    </div>
  );
  // ── FORM NUEVO/EDITAR ──
  if (vista === "nuevo" || vista === "editar") return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <Header titulo={editando ? `Editar — ${editando.nombre}` : "Nuevo Usuario"} onBack={() => { setVista("listado"); setEditando(null); setForm({ rol:"Calidad", activo:true }); setArchivoLogo(null); setErrores({}); }} />
      <div style={{ padding:"0 2rem 2rem", maxWidth:"600px", margin:"0 auto" }}>
        <div style={card}>
          <h3 style={{ fontSize:"14px", fontWeight:"600", color:"#7B5BF2", marginBottom:"12px" }}>Datos del usuario</h3>
          <span style={lbl}>Nombre completo *</span>
          <input value={form.nombre||""} onChange={e=>setForm(f=>({...f,nombre:e.target.value}))} style={{...inp,borderColor:errores.nombre?"#e63946":borde}} />
          {errores.nombre && <p style={{color:"#e63946",fontSize:"11px",margin:"3px 0 0"}}>{errores.nombre}</p>}
          <span style={lbl}>Email *</span>
          <input type="text" value={form.email||""} onChange={e=>setForm(f=>({...f,email:e.target.value}))} style={{...inp,borderColor:errores.email?"#e63946":borde}} placeholder="usuario@empresa.com o número de celular"/>
          {errores.email && <p style={{color:"#e63946",fontSize:"11px",margin:"3px 0 0"}}>{errores.email}</p>}
          <span style={{fontSize:"11px",color:subtexto,display:"block",marginTop:"12px",fontWeight:"700",textTransform:"uppercase"}}>Celular (alternativo)</span>
          <input type="text" value={form.celular||""} onChange={e=>setForm(f=>({...f,celular:e.target.value}))} style={inp} placeholder="Ej: 1123456789"/>
          <p style={{fontSize:"11px",color:subtexto,margin:"3px 0 0"}}>El empleado puede iniciar sesión con email o celular</p>
          <span style={lbl}>{editando?"Nueva contraseña (vacío = no cambiar)":"Contraseña *"}</span>
          <input type="password" onChange={e=>setForm(f=>({...f,password:e.target.value}))} style={{...inp,borderColor:errores.password?"#e63946":borde}} placeholder={editando?"••••••••":"Mínimo 6 caracteres"}/>
          {errores.password && <p style={{color:"#e63946",fontSize:"11px",margin:"3px 0 0"}}>{errores.password}</p>}
          <span style={lbl}>Empresa *</span>
          <input value={form.empresa||""} onChange={e=>setForm(f=>({...f,empresa:e.target.value}))} style={{...inp,borderColor:errores.empresa?"#e63946":borde}} placeholder="Ej: La Pyme Industrial SA"/>
          {errores.empresa && <p style={{color:"#e63946",fontSize:"11px",margin:"3px 0 0"}}>{errores.empresa}</p>}
          <span style={lbl}>Dirección empresa (para PDF)</span>
          <input value={form.empresa_direccion||""} onChange={e=>setForm(f=>({...f,empresa_direccion:e.target.value}))} style={inp} placeholder="Ej: Av. Corrientes 1234, Buenos Aires"/>
          <span style={lbl}>CUIT empresa (para PDF)</span>
          <input value={form.empresa_cuit||""} onChange={e=>setForm(f=>({...f,empresa_cuit:e.target.value}))} style={inp} placeholder="Ej: 30-12345678-9"/>
          <span style={lbl}>Logo de empresa (para PDF, opcional)</span>
          {form.logo_url && !archivoLogo && (
            <p style={{ fontSize:"12px", color:subtexto, margin:"4px 0" }}>🖼️ Ya tiene un logo cargado — elegí un archivo abajo para reemplazarlo.</p>
          )}
          {archivoLogo && (
            <p style={{ fontSize:"12px", color:"#22c55e", margin:"4px 0" }}>✅ Seleccionado: {archivoLogo.name}</p>
          )}
          <input type="file" ref={inputFotoLogoRef} accept="image/*" capture="environment" style={{ display:"none" }}
            onChange={e => {
              const f = e.target.files?.[0] || null;
              if (f && f.size > LOGO_MAX_BYTES) { alert("El logo no puede pesar más de 500KB."); e.target.value = ""; return; }
              if (f) setArchivoLogo(f);
              e.target.value = "";
            }}/>
          <input type="file" ref={inputArchivoLogoRef} accept="image/png,image/jpeg" style={{ display:"none" }}
            onChange={e => {
              const f = e.target.files?.[0] || null;
              if (f && f.size > LOGO_MAX_BYTES) { alert("El logo no puede pesar más de 500KB."); e.target.value = ""; return; }
              if (f) setArchivoLogo(f);
              e.target.value = "";
            }}/>
          <div style={{ display:"flex", gap:"8px", marginTop:"4px", flexWrap:"wrap" }}>
            <button type="button" onClick={() => inputFotoLogoRef.current?.click()}
              style={{ padding:"7px 14px", background:"#7B5BF2", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontWeight:"600", fontSize:"12px" }}>
              📷 Sacar foto
            </button>
            <button type="button" onClick={() => inputArchivoLogoRef.current?.click()}
              style={{ padding:"7px 14px", background:"none", border:`1.5px solid ${borde}`, color:texto, borderRadius:"8px", cursor:"pointer", fontWeight:"600", fontSize:"12px" }}>
              📎 Subir archivo
            </button>
          </div>
          <p style={{ fontSize:"11px", color:subtexto, margin:"4px 0 0" }}>PNG (idealmente con fondo transparente) o JPG, máx. 500KB. Se muestra en el membrete de los PDFs (rótulos, instructivos) en vez de solo el nombre de la empresa. Opcional -- sin logo, el membrete sigue funcionando solo con texto.</p>
          <span style={lbl}>Organización / Cliente (opcional)</span>
          <div style={{ display:"flex", gap:"8px", alignItems:"center" }}>
            {!nuevaOrg
              ? <select value={form.organizacion||""} onChange={e => setForm(f=>({...f, organizacion:e.target.value}))} style={{...inp, flex:1}}>
                  <option value="">— Usuario interno (sin organización) —</option>
                  {organizaciones.map(o => (
                    <option key={o.id} value={o.nombre}>{o.nombre}</option>
                  ))}
                </select>
              : <input value={form.organizacion||""} onChange={e=>setForm(f=>({...f,organizacion:e.target.value}))} style={{...inp, flex:1}} placeholder="Nombre de la nueva organización..."/>
            }
            <button type="button" onClick={() => { setNuevaOrg(!nuevaOrg); setForm(f=>({...f,organizacion:""})); }}
              style={{ padding:"8px 12px", background:nuevaOrg?"#e63946":"#7B5BF2", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"11px", fontWeight:"600", flexShrink:0 }}>
              {nuevaOrg ? "✕ Cancelar" : "+ Nueva"}
            </button>
          </div>
          <p style={{fontSize:"11px",color:subtexto,margin:"3px 0 0"}}>
            {nuevaOrg ? "Se creará la organización automáticamente." : editando ? "Cambiá la organización asignada o dejala vacía para quitarla." : "Seleccioná una organización existente o creá una nueva."}
          </p>
        </div>
        <div style={card}>
          <h3 style={{ fontSize:"14px", fontWeight:"600", color:"#09184D", marginBottom:"12px" }}>Rol</h3>
          {Object.entries(ROLES).map(([key,{label,color,descripcion}]) => (
            <button key={key} onClick={() => setForm(f=>({...f,rol:key}))}
              style={{ width:"100%", padding:"10px 14px", borderRadius:"10px", marginBottom:"6px", fontSize:"13px", cursor:"pointer", textAlign:"left", border:(form.rol||editando?.rol)===key?`2px solid ${color}`:`1px solid ${borde}`, background:(form.rol||editando?.rol)===key?`${color}18`:cardBg, color:texto }}>
              <span style={{fontWeight:"700",color}}>{label}</span>
              <span style={{display:"block",fontSize:"11px",color:subtexto,marginTop:"2px"}}>{descripcion}</span>
            </button>
          ))}
        </div>
        <button onClick={guardar} disabled={guardandoUsuario} style={{ width:"100%", padding:"14px", background:"#7B5BF2", color:"white", border:"none", borderRadius:"10px", fontSize:"15px", fontWeight:"600", cursor:"pointer", opacity:guardandoUsuario?.7:1 }}>
          {guardandoUsuario ? "Creando..." : (editando ? "Guardar cambios" : "Crear usuario")}
        </button>
      </div>
    </div>
  );
  // ── LISTADO ──
  return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100 }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Menú</button>
          <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>👥 Gestión de Usuarios</span>
        </div>
        <button onClick={() => { setEditando(null); setForm({rol:"Calidad",activo:true}); setArchivoLogo(null); setVista("nuevo"); }}
          style={{ padding:"6px 14px", background:"#7B5BF2", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"600" }}>
          + Nuevo usuario
        </button>
        {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="usuarios" oscuro={oscuro} />}
      </div>
      <div style={{ padding:"1rem 1.5rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
          {[["Total",usuarios.length,"#7B5BF2"],["Activos",usuarios.filter(u=>u.activo).length,"#22c55e"],["Inactivos",usuarios.filter(u=>!u.activo).length,"#e63946"],["Empresas",new Set(usuarios.map(u=>u.empresa)).size,"#3b82f6"]].map(([lab,val,col])=>(
            <div key={lab} style={{ background:cardBg, borderRadius:"12px", padding:"1rem", border:`1px solid ${borde}`, textAlign:"center" }}>
              <p style={{ fontSize:"22px", fontWeight:"700", color:col, margin:0 }}>{val}</p>
              <p style={{ fontSize:"11px", color:subtexto, margin:"4px 0 0" }}>{lab}</p>
            </div>
          ))}
        </div>
        <input
          value={busqueda}
          onChange={e=>setBusqueda(e.target.value)}
          placeholder="🔍 Buscar por nombre, email o empresa..."
          style={{ width:"100%", padding:"10px 14px", borderRadius:"10px", border:`1px solid ${borde}`, fontSize:"13px", boxSizing:"border-box", marginBottom:"1rem", background:cardBg, color:texto }}
        />
        {usuarios.filter(u => {
          const q = busqueda.trim().toLowerCase();
          if (!q) return true;
          return (u.nombre||"").toLowerCase().includes(q)
              || (u.email||"").toLowerCase().includes(q)
              || (u.empresa||"").toLowerCase().includes(q);
        }).map(u => (
          <div key={u.id} style={{ background:cardBg, borderRadius:"12px", padding:"1.2rem 1.5rem", border:`1px solid ${u.activo?borde:"#e6394644"}`, marginBottom:"10px", opacity:u.activo?1:.6 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
              <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
                <div style={{ width:"40px", height:"40px", borderRadius:"12px", background:`${ROLES[u.rol]?.color||"#7B5BF2"}22`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"18px", border:`1px solid ${ROLES[u.rol]?.color||"#7B5BF2"}44`, flexShrink:0 }}>
                  {(u.nombre||"?")[0].toUpperCase()}
                </div>
                <div>
                  <p style={{ fontSize:"14px", fontWeight:"700", color:texto, margin:"0 0 2px" }}>{u.nombre}</p>
                  <p style={{ fontSize:"12px", color:subtexto, margin:"0 0 2px" }}>{u.email}</p>
                  <p style={{ fontSize:"11px", color:subtexto, margin:0 }}>{u.empresa}</p>
                </div>
              </div>
              <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:"6px" }}>
                <span style={{ fontSize:"11px", fontWeight:"700", color:ROLES[u.rol]?.color, background:`${ROLES[u.rol]?.color}18`, padding:"3px 8px", borderRadius:"8px" }}>
                  {ROLES[u.rol]?.label}
                </span>
                <span style={{ fontSize:"10px", fontWeight:"600", color:u.activo?"#22c55e":"#e63946" }}>
                  {u.activo?"✅ Activo":"⛔ Inactivo"}
                </span>
              </div>
            </div>
            <div style={{ display:"flex", gap:"6px", marginTop:"10px", justifyContent:"flex-end", flexWrap:"wrap" }}>
              <button onClick={() => abrirPermisos(u)}
                style={{ padding:"5px 10px", background:"#7B5BF222", border:"1px solid #7B5BF2", borderRadius:"8px", cursor:"pointer", color:"#7B5BF2", fontSize:"11px", fontWeight:"600" }}>
                🔐 Permisos
              </button>
              <button onClick={() => toggleActivo(u.id)} style={{ padding:"5px 10px", background:"none", border:`1px solid ${borde}`, borderRadius:"8px", cursor:u.id===1?"not-allowed":"pointer", color:subtexto, fontSize:"11px", opacity:u.id===1?.4:1 }}>
                {u.activo?"Desactivar":"Activar"}
              </button>
              <button onClick={async () => {
                setEditando(u);
                const { data } = await supabase.from("usuario_organizaciones").select("organizaciones(nombre)").eq("usuario_id", u.id).maybeSingle();
                setForm({nombre:u.nombre, email:u.email, celular:u.celular||"", empresa:u.empresa, empresa_direccion:u.empresa_direccion||"", empresa_cuit:u.empresa_cuit||"", logo_url:u.logo_url||"", rol:u.rol, activo:u.activo, organizacion: data?.organizaciones?.nombre || ""});
                setArchivoLogo(null);
                setVista("editar");
              }}
                style={{ padding:"5px 10px", background:"none", border:"1px solid #7B5BF2", borderRadius:"8px", cursor:"pointer", color:"#7B5BF2", fontSize:"11px", fontWeight:"600" }}>
                ✏️ Editar
              </button>
              <button onClick={() => u.id!==1&&setConfirmEliminar(u.id)}
                style={{ padding:"5px 10px", background:"none", border:`1px solid ${u.id===1?borde:"#e63946"}`, borderRadius:"8px", cursor:u.id===1?"not-allowed":"pointer", color:u.id===1?subtexto:"#e63946", fontSize:"11px", opacity:u.id===1?.4:1 }}>
                🗑 Eliminar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
